import RouteBackBar from './route-back-bar';

export { default } from './go-back-bar';
export { RouteBackBar };
